import React from 'react';
import { Typography } from '@mui/material';

import { Dialog } from '@paragon/popup-state';
import { createScrollbarStyling } from '@paragon/themes';

import { getProjectLayoutModel } from '../../store/selectors/getProjectLayoutModel';
import { useAppSelector } from '../hooks';
import { LayoutModelPropertiesPanel } from '../interface/panels/PropertiesPanel';

export function SharedComponentSetInfoDialog() {
  const projectLayoutModel = useAppSelector(getProjectLayoutModel);
  const sharedComponentSet = useAppSelector((state) => state.sharedComponentSet.sharedComponentSet);

  if (!projectLayoutModel && !sharedComponentSet) return null;

  return (
    <Dialog variant="design" contentSx={createScrollbarStyling}>
      {sharedComponentSet && (
        <Typography align="center">
          Shared Component Set created by {sharedComponentSet.contactName} ({sharedComponentSet.contactEmail}) on{' '}
          {Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' }).format(
            new Date(sharedComponentSet.created),
          )}
        </Typography>
      )}
      {projectLayoutModel && (
        <LayoutModelPropertiesPanel isViewOnly selectedEntries={[{ type: 'project', item: projectLayoutModel }]} />
      )}
    </Dialog>
  );
}
